import { render, staticRenderFns } from "./VideoIframe.vue?vue&type=template&id=e2184d6a"
import script from "./VideoIframe.vue?vue&type=script&lang=js"
export * from "./VideoIframe.vue?vue&type=script&lang=js"
import style0 from "./VideoIframe.vue?vue&type=style&index=0&id=e2184d6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports